// @ts-nocheck
import { UPGRADE_REQUEST_ERROR, UPGRADE_REQUEST_LOADING, UPGRADE_REQUEST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const UpgradeRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPGRADE_REQUEST_LOADING:
            return Object.assign({}, state, { loading: true })
        case UPGRADE_REQUEST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case UPGRADE_REQUEST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

